import {
  Form,
  Input,
  Modal,
  Select,
  Button,
  message,
  notification,
} from "antd";
import React, { useEffect, useState } from "react";
import countryCodes from "../../utils/CountryCodes.json";
import { updateProfileInfoApi } from "../../api/common";
import WebUtils from "../../utils/WebUtils";
import Loader from "../Loader";
import Utils from "../../utils/Utils";

const ProfileUpdateModal = ({ open, handleCancel, userIdentifier }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const profileData = Utils.getProfileData();

  const handleChange = (value) => {
    const countryEl = document.querySelector(".country-select");
    if (countryEl) {
      countryEl.querySelector(".ant-select-selection-item").innerHTML = value;
    }
    form.setFieldValue("countryCode", value);
  };

  const strictFilterOption = (input, option) => {
    const normalizedInput = input.toLowerCase();
    const optionText = option.children[0].toLowerCase();
    const optionCode = option.children[2].toLowerCase();

    return (
      optionText.includes(normalizedInput) ||
      optionCode.includes(normalizedInput)
    );
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const requestBody = {
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
        mobileNumber: values.phoneNumber.trim(),
        countryCode: values.countryCode,
      };

      setLoading(true);
      let url = `${updateProfileInfoApi}?userIdentifier=${userIdentifier}`;
      const result = await WebUtils.httpOperations(url, requestBody, "POST");

      setLoading(false);

      if (
        result?.data?.resultStatusInfo?.resultCode?.toLowerCase() === "success"
      ) {
        let body = {
          ...requestBody,
          email: profileData?.email,
        };

        localStorage.setItem("userData", JSON.stringify(body));

        notification.success({
          message: "Success",
          description: "Profile info updated successfully!",
        });

        handleCancel();
      } else {
        notification.error({
          message: "Error",
          description: "Failed to update profile info!",
        });
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  // useEffect(() => {
  //   const countryEl = document.querySelector(".country-select");
  //   countryEl.querySelector(".ant-select-selection-item").innerHTML = "+91";
  // }, []);

  useEffect(() => {
    // Set default country code visually
    const countryEl = document.querySelector(".country-select");
    if (countryEl) {
      countryEl.querySelector(".ant-select-selection-item").innerHTML =
        profileData?.countryCode || "+91";
    }

    // Prefill form fields
    form.setFieldsValue({
      firstName: profileData?.firstName || "",
      lastName: profileData?.lastName || "",
      countryCode: profileData?.countryCode || "+91",
      phoneNumber: profileData?.mobileNumber || "",
    });
  }, [profileData, form]);

  return (
    <>
      {loading && <Loader />}
      <Modal
        open={open}
        onCancel={handleCancel}
        title={
          <div className="text-gray-900 font-semibold text-lg">
            Update Profile Info
          </div>
        }
        centered
        footer={
          <div className="flex justify-center gap-3 mt-6">
            <button
              className="w-[49%] btn-white px-3 py-[.6rem] rounded-[6px]"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="flex-1 btn-orange px-3 py-[.6rem] rounded-[6px]"
            >
              Update Profile
            </button>
          </div>
        }
        width={450}
      >
        <Form form={form} layout="vertical" className="mt-4">
          {/* First Name Field */}
          <Form.Item
            name="firstName"
            className="m-0"
            label={
              <span className="text-[#344054] font-medium text-[.85rem]">
                First Name
              </span>
            }
            rules={[
              {
                required: true,
                message: "Please enter your first name!",
              },
            ]}
          >
            <Input
              placeholder="Enter your first name"
              className="custom-input py-2"
            />
          </Form.Item>

          {/* Last Name Field */}
          <Form.Item
            name="lastName"
            className="m-0 mt-3"
            label={
              <span className="text-[#344054] font-medium text-[.85rem]">
                Last Name
              </span>
            }
            rules={[
              {
                required: true,
                message: "Please enter your last name!",
              },
            ]}
          >
            <Input
              placeholder="Enter your last name"
              className="custom-input py-2"
            />
          </Form.Item>

          {/* Phone Number Field */}
          <Form.Item
            label={
              <span className="text-[#344054] font-medium text-[.85rem] flex items-center gap-1">
                <span className="text-red-400 font-normal text-[1rem]">*</span>{" "}
                Phone Number
              </span>
            }
            className="p-0 m-0 mt-3"
          >
            <Input.Group compact>
              <Form.Item
                name="countryCode"
                noStyle
                initialValue="+91"
                rules={[
                  {
                    required: true,
                    message: "Please select your country code!",
                  },
                ]}
              >
                <Select
                  className="country-select"
                  style={{ width: "23%" }}
                  showSearch
                  onChange={handleChange}
                  size="large"
                  placeholder="Select country"
                  filterOption={strictFilterOption}
                  dropdownStyle={{ width: "300px" }}
                >
                  {countryCodes.map((country) => (
                    <Select.Option key={country.name} value={country.code}>
                      {country.name} ({country.code})
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="phoneNumber"
                noStyle
                rules={[
                  {
                    required: true,
                    message: "Please enter your phone number!",
                  },
                ]}
              >
                <Input
                  style={{ width: "77%" }}
                  placeholder="Enter phone number"
                  size="large"
                  className="custom-number-input"
                />
              </Form.Item>
            </Input.Group>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ProfileUpdateModal;
